import React from 'react';
import { buildCampaignDetailRows } from './ticketCampaignDetailsFields';
import { parseTicketCampaignSnapshot } from './ticketCampaignSnapshot';

interface TicketCampaignDetailsPanelProps {
  details: string;
}

const TicketCampaignDetailsPanel: React.FC<TicketCampaignDetailsPanelProps> = ({ details }) => {
  const rows = buildCampaignDetailRows(parseTicketCampaignSnapshot(details));

  if (rows.length === 0) {
    return (
      <p className="text-sm text-slate-500 px-1 py-2">
        No campaign details were captured for this ticket.
      </p>
    );
  }

  return (
    <dl className="divide-y divide-slate-100 rounded-lg border border-slate-200 bg-slate-50/60">
      {rows.map((row) => (
        <div key={row.label} className="grid grid-cols-[minmax(0,140px)_1fr] gap-3 px-3 py-2 text-sm">
          <dt className="text-slate-500 font-medium">{row.label}</dt>
          <dd className="text-slate-900 break-words">{row.value}</dd>
        </div>
      ))}
    </dl>
  );
};

export default TicketCampaignDetailsPanel;
